<template>
  <j-modal 
    :title="title" 
    :width="width" 
    :visible="visible" 
    :confirmLoading="confirmLoading" 
    :keyboard="false" 
    :forceRender="true" 
    switchFullscreen 
    @cancel="handleCancel" 
    style="top:20px;height: 95%;"
    >
    <template slot="footer">
      <a-button @click="handleCancel">关闭</a-button>
    </template>
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-row class="form-row" :gutter="24">
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="报告单号" prop="recordCode">
                  <span>{{form.recordCode}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="报告日期" prop="date">
                  <span>{{form.date}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="受理人" prop="acceptedBy">
                  <span>{{form.acceptedBy}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品编号" prop="productNumber">
                  <span>{{form.productNumber}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品名称" prop="productName">
                  <span>{{form.productName}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="规格型号" prop="productModel">
                  <span>{{form.productModel}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品注册证号" prop="productRegistrationNumber">
                  <span>{{form.productRegistrationNumber}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="注册人/备案人" prop="regBy">
                  <span>{{form.regBy}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="生产企业许可证" prop="productionEnterpriseLicense">
                  <span>{{form.productionEnterpriseLicense}}</span>
                </a-form-model-item>
              </a-col>
              
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="批号/序列号" prop="serialNumber">
                  <span>{{form.serialNumber}}</span>
                </a-form-model-item>
              </a-col>
              
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="生产日期" prop="productData">
                  <span>{{form.productData}}</span>
                </a-form-model-item>
              </a-col>
              
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="投诉方单位" prop="complaint">
                  <span>{{form.complaint}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="投诉方联系人" prop="complaintContacts">
                  <span>{{form.complaintContacts}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="投诉方联系电话" prop="complaintPhoneNumber">
                  <span>{{form.complaintPhoneNumber}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供货方单位" prop="supplier">
                  <span>{{form.supplier}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供货方联系人" prop="supplierContacts">
                  <span>{{form.supplierContacts}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供货方联系电话" prop="supplierPhoneNumber">
                  <span>{{form.supplierPhoneNumber}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="报告人" prop="preparedBy">
                  <span>{{form.preparedBy}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="批准人" prop="approveBy">
                  <span>{{form.approveBy}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="问题描述" prop="problemRemark">
                  <span>{{form.problemRemark}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="事故原因" prop="reason">
                  <span>{{form.reason}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="整改措施" prop="measure">
                  <span>{{form.measure}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="责任部门" prop="responsibleDepartment">
                  <span>{{form.responsibleDepartment}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="批准意见" prop="opinion">
                  <span>{{form.opinion}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注" prop="remark">
                  <span>{{form.remark}}</span>
                </a-form-model-item>
              </a-col>
              <!-- <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="附件">
                  <j-image-upload v-model="fileList" bizPath="material" text="上传" isMultiple></j-image-upload>
                </a-form-model-item>
              </a-col> -->
            </a-row>
        
      </a-form>
    </a-spin>
    <vendor-modal ref="vendorModalForm" @ok="vendorModalFormOk"></vendor-modal>
    <depot-modal ref="depotModalForm" @ok="depotModalFormOk"></depot-modal>
    <batch-set-depot ref="batchSetDepotModalForm" @ok="batchSetDepotModalFormOk"></batch-set-depot>
    <import-item-modal ref="importItemModalForm" @ok="importItemModalFormOk"></import-item-modal>
    <wait-bill-list ref="waitBillList" @ok="waitBillListOk"></wait-bill-list>
    <workflow-iframe ref="modalWorkflow"></workflow-iframe>
  </j-modal>
</template>
<script>
import pick from 'lodash.pick'
import VendorModal from '../../system/modules/VendorModal'
import DepotModal from '../../system/modules/DepotModal'
import BatchSetDepot from '../dialog/BatchSetDepot'
import ImportItemModal from '../dialog/ImportItemModal'
import WorkflowIframe from '@/components/tools/WorkflowIframe'
import { FormTypes } from '@/utils/JEditableTableUtil'
import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
import { BillModalMixin } from '../mixins/BillModalMixin'
import { getMpListShort } from '@/utils/util'
import JUpload from '@/components/jeecg/JUpload'
import JDate from '@/components/jeecg/JDate'
import Vue from 'vue'
import WaitBillList from '../dialog/WaitBillList'
export default {
  name: 'OtherInModal',
  mixins: [JEditableTableMixin, BillModalMixin],
  components: {
    VendorModal,
    DepotModal,
    BatchSetDepot,
    ImportItemModal,
    WaitBillList,
    WorkflowIframe,
    JUpload,
    JDate,
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes,
    },
  },
  data() {
    return {
      title: '详情',
      width: '1600px',
      moreStatus: false,
      // 新增时子表默认添加几行空数据
      addDefaultRowNum: 1,
      visible: false,
      operTimeStr: '',
      prefixNo: 'XJJU',
      fileList: [],
      rowCanEdit: true,
      //出入库管理开关，适合独立仓管场景
      inOutManageFlag: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      url: {
        add: '/quality/spotInspection/add',
        edit: '/quality/spotInspection/edit',
        detailList: '/quality/inspectionAssociation/getDetailList',
      },
    }
  },
  created() {},
  methods: {
    show(result){
      this.visible = true
      this.form = result.info
    },
    handleCancel() {
      this.visible = false
    },

  },
}
</script>
<style scoped>
</style>